import { atom } from "recoil";

export const CURRENT_PAGE = atom({
    key: "current_page",
    default: "",
});

export const SOLUTION_SUBJECT_ID = atom({
    key: "subject_id",
    default: "",
});

export const SOLUTION_CONTENT_ID = atom({
    key: "content_id",
    default: "",
});

export const IS_MODIFY_MODE = atom({
    key: "is_modify_mode",
    default: false,
});

export const CONTENT_TYPE = atom({
    key: "content_type",
    default: "text",
});

export const CURRENT_CONTENT = atom({
    key: "current_content",
    default: "",
});

export const LAST_SELECT_PAGE = atom({
    key: "last_selected_page",
    default: 0,
});
